import todo from "./images/icon-todo.svg";
import calender from "./images/icon-calendar.svg";
import reminder from "./images/icon-reminders.svg";
import planning from "./images/icon-planning.svg";
import arrowDown from "./images/icon-arrow-down.svg";
import arrowUp from "./images/icon-arrow-up.svg";
import menu from "./images/icon-menu.svg";
import closeMenu from "./images/icon-close-menu.svg";
const SideBar = ({ subCompanyList, subFeatures, handleClick, isMenuOpen }) => {
  const style = {
    display: isMenuOpen ? "none" : "block",
  };

  return (
    <div className="forHideSidebar">
      {isMenuOpen ? (
        <button className="menuBtn" value="openMenu" onClick={handleClick}>
          <img src={menu} alt="open menu" />
        </button>
      ) : (
        <div className="sidebar" style={style}>
          <button className="menuBtn" value="closeMenu" onClick={handleClick}>
            <img src={closeMenu} alt="close menu" />
          </button>
          <ul className="sidebarList">
            <li>
              <button value="features" onClick={handleClick}>
                features
                {<img src={subFeatures ? arrowUp : arrowDown} alt="features" />}
                {subFeatures ? (
                  <ul className="subFeatures">
                    <li>
                      <img src={todo} alt="todo list" />
                      todo list
                    </li>
                    <li>
                      <img src={calender} alt="calender" />
                      calendar
                    </li>
                    <li>
                      <img src={reminder} alt="reminder" />
                      reminder
                    </li>
                    <li>
                      <img src={planning} alt="planning" />
                      planning
                    </li>
                  </ul>
                ) : null}
              </button>
            </li>
            <li>
              <button value="company" onClick={handleClick}>
                company
                {
                  <img
                    src={subCompanyList ? arrowUp : arrowDown}
                    alt="company"
                  />
                }
                {subCompanyList ? (
                  <ul className="companyList">
                    <li>history</li>
                    <li>our team</li>
                    <li>blog</li>
                  </ul>
                ) : null}
              </button>
            </li>
            <li>
              <button onClick={handleClick}>careers</button>
            </li>
            <li>
              <button onClick={handleClick}>about</button>
            </li>
          </ul>
          <div className="btn-container">
            <button>login</button>
            <button className="register-btn">register</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SideBar;

{
  /* <ul>
  <li>
    <img src={todo} alt="todo list" />
    todo list
  </li>
  <li>
    <img src={calender} alt="calender" />
    calendar
  </li>
  <li>
    <img src={reminder} alt="reminder" />
    reminder
  </li>
  <li>
    <img src={planning} alt="planning" />
    planning
  </li>
</ul>; */
}
